import React from 'react'
import {Box, Switch, Typography, Tooltip} from "@material-ui/core";
import {HelpOutline} from "@material-ui/icons";

const ConfigSwitch = ({value, onChange, name, marginTop, marginBottom, title, readOnly, titleVariant = "h6", titleBold, tip, prefix, className, style}) => {
  return (
    <Box display="flex" alignItems="center" flex={1} marginTop={marginTop} marginBottom={marginBottom} className={className} style={style}>
      <Box display="flex" alignItems="center" style={{marginRight: "auto"}}>
        {prefix}
        <Typography variant={titleVariant} style={{fontWeight: titleBold ? "bold" : ""}}>
          {title}
        </Typography>
        { tip && (
          <Tooltip title={tip}>
            <HelpOutline />
          </Tooltip>
        )}
      </Box>
      <Switch
        name={name}
        checked={value}
        color="primary"
        onChange={onChange}
        size="small"
        disabled={readOnly}
      />
    </Box>
  )
}

export default ConfigSwitch
